const LOCALE_FILENAME = {
  MODAL_RATING: "modalRating",
  LIST_USER_WORKED_TIME_COMPONENT: "list-user-worked-time-component",
};

export default LOCALE_FILENAME;
